<template>
  <main class="flex items-center m-auto">
      <div class="text-center">
        <div class="text-warning text-2xl mb-4">Няма интернет връзка!</div>
        <div><button @click="checkForInternet" class="btn btn-info">Провери?</button></div>
      </div>
  </main>
</template>

<script>
  import ConnectionService from '../services/connection.service'
export default {
  name: "connection",
  data() {
    return {

    };
  },

  computed: {

  },
  methods: {
    checkForInternet(){
      window.location.href='/';
    },
  }
};
</script>
